var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_distribution",
            title: "Funktionen / Module",
          },
          on: { save: _vm.saveFirmFunctions },
        },
        [
          _c("h2", [_vm._v("Funktionen")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Aktiv",
                  property: "active",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "SilverDAT 3 / MyClaim Firma",
                  property: "isDatFirm",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Externer Gutachter",
                  property: "isExternalAppraiser",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Aktenanlage durch Werkstattauftrag",
                  property: "canCreateRecordsWithCross",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "VIN Abfragen aktivieren",
                  property: "isVinRequestEnabled",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "2-Faktor Authentifizierung erforderlich",
                  property: "requires2fa",
                  type: "checkbox",
                },
                scopedSlots: _vm._u(
                  [
                    _vm.firmGroupOverride("requires2fa")
                      ? {
                          key: "display-value",
                          fn: function () {
                            return [
                              _c("span", [
                                _c("b", [_vm._v("Ja (von FG)")]),
                                _c("br"),
                              ]),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Gutachterrechnung ausblenden",
                  property: "shouldHideAppraiserFees",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Vermerk-E-Mails an Firmenbenutzer senden",
                  property: "sendNoteEmailsToFirmUsers",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Schadenpositionen mit KI anlegen",
                  property: "canCreateCostUnitsWithOcr",
                  type: "checkbox",
                },
                scopedSlots: _vm._u(
                  [
                    _vm.firmGroupOverride("canCreateCostUnitsWithOcr")
                      ? {
                          key: "display-value",
                          fn: function () {
                            return [
                              _c("span", [
                                _c("b", [_vm._v("Ja (von FG)")]),
                                _c("br"),
                              ]),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Nutzung von Kundenvorlagen",
                  property: "canUseCustomerTemplates",
                  type: "checkbox",
                },
                scopedSlots: _vm._u(
                  [
                    _vm.firmGroupOverride("canUseCustomerTemplates")
                      ? {
                          key: "display-value",
                          fn: function () {
                            return [
                              _c("span", [
                                _c("b", [_vm._v("Ja (von FG)")]),
                                _c("br"),
                              ]),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "BlueNow Debitoren Key",
                  property: "blueNowDebitorKey",
                  required: false,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "PIN externer Dienstleister",
                  property: "externalPin",
                  required: false,
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "bezahl.de Organisation",
                  "options-loader": _vm.loadBezahlDeOrgOptions,
                  property: "bezahlDeOrg",
                  type: "autocomplete",
                },
              }),
              _vm._v(" "),
              _vm.formContext.form.getProperty("bezahlDeOrg")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "bezahl.de Standort-ID",
                      property: "bezahlDeLocation",
                      type: "text",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formContext.isInEditMode
            ? _c("firm-bezahl-de-org-create-modal", {
                attrs: { "firm-id": Number(_vm.firmId) },
                on: { "org-created": _vm.reloadFirmFunctionsForm },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h2", [_vm._v("Module")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Schaden-Manager aktiv",
                  property: "damageModuleActive",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _vm.formContext.form.getProperty("damageModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Beginn Aktivierung",
                      "max-date": null,
                      property: "damageModuleDateBegin",
                      required: "",
                      type: "datepicker",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.form.getProperty("damageModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Beginn Abrechnung",
                      "max-date": null,
                      property: "damageModuleBillingDateBegin",
                      type: "datepicker",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.form.getProperty("damageModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Ende Aktivierung",
                      "max-date": null,
                      property: "damageModuleDateEnd",
                      type: "datepicker",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.formContext.form.getProperty("damageModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      "hide-label": true,
                      label: "Anlieferungs-Vorgänge aktivieren",
                      property: "enableDeliveryClaims",
                      type: "checkbox",
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.firmGroupOverride("enableDeliveryClaims")
                          ? {
                              key: "display-value",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _c("b", [_vm._v("Ja (von FG)")]),
                                    _c("br"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.form.getProperty("damageModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      "hide-label": true,
                      label: "Inkasso-Vorgänge aktivieren",
                      property: "enableDebtCollectionClaims",
                      required: false,
                      type: "checkbox",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.form.getProperty("damageModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      "hide-label": true,
                      label: "Regress-Vorgänge aktivieren",
                      property: "enableRegressClaims",
                      required: false,
                      type: "checkbox",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-label": true,
                  label: "Mobilitäts-Manager aktiv",
                  property: "rentModuleActive",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _vm.formContext.form.getProperty("rentModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Beginn Aktivierung",
                      "max-date": null,
                      property: "rentModuleDateBegin",
                      required: "",
                      type: "datepicker",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.form.getProperty("rentModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Beginn Abrechnung",
                      "max-date": null,
                      property: "rentModuleBillingDateBegin",
                      type: "datepicker",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.formContext.form.getProperty("rentModuleActive")
                ? _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Ende Aktivierung",
                      "max-date": null,
                      property: "rentModuleDateEnd",
                      type: "datepicker",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }